import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DialogBase } from '../../dialogs/base-dialog';

@Component({
  selector: 'beta-group-dialog',
  templateUrl: './beta-group.html'
})

export class BetaGroupDialogComponent extends DialogBase {
  public safeResourceUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  initDialog() {
    const accountName = this.extraData.accountName;
    this.safeResourceUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(`
      https://analytics.clickdimensions.com/clickdimensionscom-ak7l5/pages/x5dl59jieeebjeahg2rrmq.html?accountName=${accountName}`);
  }
}
